import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-dialog-try-hardware',
    templateUrl: './dialog-try-hardware.component.html',
    // styleUrls: ['./dialog-try-hardware.component.scss'],
    standalone: false,
})
export class DialogTryHardwareComponent implements OnInit {
    @Input() showDialog = false;
    @Output() tryHardware = new EventEmitter<void>();
    @Output() onHide = new EventEmitter<void>();

    constructor() {}

    ngOnInit(): void {}
}
